const currencyStyle = (lang, symbol, total) => {
  if (lang === 'fr') return total + symbol;
  else return symbol + total;
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const zeroPad = (num, places) => String(num).padStart(places, '0');

module.exports = {
  currencyStyle,
  sleep,
  zeroPad,
};
